import React, { useState } from 'react'
import { Card, CardContent, Typography, Box } from '@mui/material'
import GenericButton from '../../components/GenericButton'
import { AccountTreeOutlined } from '@mui/icons-material'
import CsvMappingUpload from '../../components/CsvMappingUpload'
import { notification } from '../../components/Notifications'
import { getDivisionCoursesApi } from '../../store/slices/courseCatalogSlice/api'
import { ButtonSize, ButtonType } from '../../components/GenericButton/styles'
import { useQuery } from '@tanstack/react-query'
import { grey } from '../../colors'

interface CreateNewReportingHierarchyProps {
  params?: Record<string, any>
}

export const CreateNewReportingHierarchy: React.FC<CreateNewReportingHierarchyProps> = ({ params }) => {
  const [showUpload, setShowUpload] = useState(false)

  const { refetch: refetchDivisionCourses } = useQuery({
    queryKey: ['divisionCourses', params],
    queryFn: () => getDivisionCoursesApi({ params }),
    enabled: false

  })

  const handleUploadSuccess = async (): Promise<void> => {
    await refetchDivisionCourses()
    setShowUpload(false)
    window.location.reload()
  }

  return (
    <>
      <Box display="flex" alignItems="center" justifyContent="center" sx={{ height: '100vh', width: '100vw', position: 'fixed', top: 0, left: 0 }}>
        <Card elevation={6} sx={{ minWidth: 400, p: 4, borderRadius: 2, boxShadow: 3 }}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Typography variant="h6" fontWeight={700} align="center" gutterBottom>
              Create a Reporting Hierarchy
            </Typography>
            <Typography variant="body1" align="center" sx={{ mb: 2, color: grey[500] }}>
              To setup your ClassRanked system, start by creating a Reporting Hierarchy
            </Typography>
            <GenericButton
              buttonType={ButtonType.Primary}
              label="Upload Reporting Hierarchy"
              startIcon={<AccountTreeOutlined />}
              onClick={() => { setShowUpload(true) }}
              buttonSize={ButtonSize.Large}
              sx={{ mt: 2, minWidth: 220 }}
            />
          </CardContent>
        </Card>
      </Box>
      <CsvMappingUpload
        csvHeaderEndpoint="/api/divisions/csv_headers"
        isOpen={showUpload}
        modalTitle="Reporting Hierarchy"
        onClose={() => { setShowUpload(false) }}
        uploadCsvEndpoint="/api/divisions/"
        onSuccess={() => { void handleUploadSuccess() }}
      />
    </>
  )
}
